export default class BaseModel {
  constructor(props) {
    this.mapProps(props);
  }

  mapProps(props) {}
  getObject() {}
}